import React, { useState, useEffect } from "react";

function Bannerz() {
  

  const images = [
    {
      url: "https://i0.wp.com/www.lacedaily.com/wp-content/uploads/2021/04/eleuthera-2021-6.jpg?w=1200&ssl=1",
    },

   

    {
      url: " https://cdn.elebase.io/5d486d2e-87b2-401e-a93d-d0502e0d1a87/c13ce697-22a2-4e2e-af19-525cb64e556e-hatchet-bay-harbour.jpg?w=680&h=382&fit=crop&rot=auto&dpr=2&q=75",
    },


    {
      url: "https://www.eleutheradirect.com/blog/wp-content/uploads/2020/11/Untitled-1.jpg",
    },
    {
      url: "https://images.contentstack.io/v3/assets/blt00454ccee8f8fe6b/blt86851678a14bb293/60ab387a4adeb65c03d76234/US_Eleuthera_The_Bahamas_Header.jpg?width=1440&quality=70&auto=webp",
    },

    /* 
    {
      url: "https://www.myoutislands.com/public_docs/blog/content/boi-news-eleuthera-is-loveable-for-these-reasons.jpg",
    },
*/


  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  const bgImageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  };

  return (
    <>
      <section
        className="banner-section"
        style={{
          //backgroundColor: '#00b712',
         // backgroundImage: 'linear-gradient(95deg, #00690a 0%, #3a9e0e 79%)'
         position: 'relative',
         height:'600px'
        }}
      >
         <img alt="Background Shape" style={bgImageStyle}  src={images[currentIndex].url}
            />
      

  
    </section>
  </>
);
}

export default Bannerz;